import { request } from '../request';
import { getGameSession } from './ad-game-session-utils';
import { AdReqType } from './types/ad-request-enum';
import { AdRequest } from './types/ad-request';
import { PlatformMap, RPCCallerIdMap, getPlatform } from './ad-const';
import { adRequestCookieManager } from './ad-request-cookie';
import { AdUtils, getAdUserAgent } from './ad-utils';
import { AdInfo } from './types/ad';
import { parseAdInfoFromListRepData } from './ad-parser';
import { AdExp, AdExpType } from './ad-exps';

const AD_LIST_URL = 'https://pbaccess.video.qq.com/trpc.business_feeds.dsp_feeds_pc.IndependentPCFeeds/GetAdCards';
const AD_LIST_URL_TEST = 'https://tpbaccess.video.qq.com/trpc.business_feeds.dsp_feeds_pc.IndependentPCFeeds/GetAdCards';

const GET_AD_LIST_URL = () => {
  if (AdUtils.isDebugEnv()) {
    // console.log("[ad] GetAdCards-test");
    return AD_LIST_URL_TEST;
  }
  return AD_LIST_URL;
};

export class AdRequestManager {
  public static getAdHeaders = () => {
    const PT = getPlatform();
    adRequestCookieManager.refreshIfNeeded();
    const headers = {
      guid: adRequestCookieManager.guid || '',
      vdevice_density_dpi: adRequestCookieManager.dpi || '',
      vdevice_imei: adRequestCookieManager.imei || '',
      vdevice_imsi: adRequestCookieManager.imsi || '',
      vdevice_omgid: adRequestCookieManager.omgid || '',
      vdevice_guid: adRequestCookieManager.guid || '',
      vdevice_qimei: adRequestCookieManager.qimei || '',
      vdevice_qimei36: adRequestCookieManager.qimei36 || '',
      vversion_platform: PlatformMap[PT],
      vversion_platform_version: adRequestCookieManager.platformVersion || '',
      vversion_name: adRequestCookieManager.versionName || '',
      vversion_code: adRequestCookieManager.versionCode || '',
      vversion_channel_id: adRequestCookieManager.channelId || '',
      video_appid: RPCCallerIdMap[PT],
      vbucket_plat_bucketid: adRequestCookieManager.bucketId || '',
      vnetwork_mode: AdUtils.getNetStatusReportValue(),
      'user-agent': getAdUserAgent(),
    };

    return headers;
  };

  public static requestAdList = async (
    reqType: AdReqType,
    pageId: string,
    pageNum: number,
  ) => {
    // console.log("[ad]requestAdList", reqType, pageId, pageNum);
    const headers = AdRequestManager.getAdHeaders();
    let expIds: string[] = [];
    switch (reqType) {
      case AdReqType.AD_REQ_TYPE_PLAYER_SWITCH:
        expIds = AdExp.getSspExpIds(AdExpType.AD_EXP_TYPE_SHORT_DRAMA_SWITCH);
        break;
      case AdReqType.AD_REQ_TYPE_REC_LIST:
        expIds = AdExp.getSspExpIds(AdExpType.AD_EXP_TYPE_SHORT_DRAMA_COMMENT);
        break;
      case AdReqType.AD_REQ_TYPE_SEARCH_PAGE:
        expIds = AdExp.getSspExpIds(AdExpType.AD_EXP_TYPE_SEARCH);
        break;
      case AdReqType.AD_REQ_TYPE_GAME_QRCODE:
        expIds = AdExp.getSspExpIds(AdExpType.AD_EXP_TYPE_GAME_QRCODE);
        break;
      case AdReqType.AD_REQ_TYPE_GAME_REC_LIST:
        expIds = AdExp.getSspExpIds(AdExpType.AD_EXP_TYPE_GAME_REC_LIST);
        break;
      default:
        break;
    }

    const reqParams = {
      req_type: reqType,
      flush_num: pageNum,
      page_id: pageId,
      strategy_ids: expIds,
      trans_data: {
        game_sessions: getGameSession(),
      },
    };

    const res = await request.post<AdRequest.GetAdListRep>(
      `${GET_AD_LIST_URL()}?video_appid=${headers.video_appid}`,
      reqParams,
      { withCredentials: true, headers },
    );
    if (typeof res === 'string') {
      // console.log("[ad]getAdList error: res-string", res);
      return [];
    }
    if (res.data.ret !== 0 || !res.data.data || !res.data.data.ads) {
      // console.log("[ad]getAdList error: no ads", res);
      return [];
    }
    const repData = res.data.data;
    return this.handleAdListResponse(repData);
  };

  public static handleAdListResponse = (repData: AdRequest.AdListRepData) => {
    // console.log("[ad]handleAdListResponse", repData);
    let cards: AdInfo[] | null = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < repData.ads.length; i++) {
      const adItem = repData.ads[i];
      if (adItem.order?.is_empty) {
        // 广告出现空单情况
        cards = null;
        break;
      }
      const adInfo = parseAdInfoFromListRepData(adItem);
      if (!adInfo) {
        continue;
      }
      cards.push(adInfo);
    }
    return cards;
  };

  public static cancelAllRequest = () => {
    request.cancelAllRequest();
  };
}
